import React from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import ImageIcon from '@mui/icons-material/ImageRounded';
import SettingsPanelSection from '../SettingsPanelSection';
import VideoElementsEditor from '../../components/VideoElementsEditor';
import ImageElementMediaPickerDialog from '../../MediaPickers/ImageElementMediaPickerDialog';
import CircleProgressButton from '../../../../buttons/CircleProgressButton';
import { mediaPickerActions } from '../../MediaPickers/store';
import { createActions } from '../../store';
import { ELEMENTS_PANEL_TABS, MAX_IMAGE_ELEMENTS } from '../../CreatePageConstants';

const styles = theme => ({
    tabsContainer: {
        background: theme.palette.action.hover,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        '& .MuiTabs-indicator': {
            display: 'none',
        },
    },
    tab: {
        minWidth: 0,
        transition: theme.transitions.create('background', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shortest,
        }),
        '&:hover': {
            background: theme.palette.action.hover
        },
        '&.Mui-selected': {
            color: "white",
            background: theme.palette.action.selected,
            fontWeight: 500
        },
        textTransform: 'none',
        fontSize: 15,
        fontWeight: 400
    }
});

const SettingsPanelSectionElements = ({ classes, elementsSelectedTab, imageElementsLength, openImageElementPicker, selectElementsTab }) => (
    <SettingsPanelSection
        id='elements-panel-section'
        title='Elements'
        action={
            <CircleProgressButton
                variant='outlined'
                color='inherit'
                startIcon={<ImageIcon />}
                size='small'
                disabled={imageElementsLength >= MAX_IMAGE_ELEMENTS}
                onClick={() => openImageElementPicker()}
            >
                Add Image
            </CircleProgressButton>
        }
    >
        <Tabs
            variant='fullWidth'
            value={elementsSelectedTab}
            onChange={(event, selectedTab) => selectElementsTab(selectedTab)}
            className={classes.tabsContainer}
        >
            <Tab
                label='Other'
                className={classes.tab}
                id='elements-other-tab'
                aria-controls='elements-other-panel'
            />
            <Tab
                label='Images'
                className={classes.tab}
                id='elements-image-elements-tab'
                aria-controls='elements-image-elements-panel'
            />
        </Tabs>

        <VideoElementsEditor selectedTab={elementsSelectedTab} />

        {/* The picker stays mounted whichever tab is on screen, because the button in the header
            above opens it from both of them. */}
        <ImageElementMediaPickerDialog />
    </SettingsPanelSection>
);

const mapStateToProps = (state) => ({
    elementsSelectedTab: state.create.elementsSelectedTab ?? ELEMENTS_PANEL_TABS.OTHER,
    imageElementsLength: (state.createPreview.present.videoSettings.elements.imageElements || state.createPreview.present.videoSettings.elements.images || []).length
});

const mapDispatchToProps = (dispatch) => {
    // No target index means the picked image is added as a new element.
    const openImageElementPicker = () => dispatch(mediaPickerActions.openImageElementPicker());
    const selectElementsTab = (selectedTab) => dispatch(createActions.setProperty('elementsSelectedTab', selectedTab));

    return { openImageElementPicker, selectElementsTab };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SettingsPanelSectionElements, styles));
